import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Revisor } from '../../../models/revisor.model';
import {  Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-revisor",
    templateUrl: "./revisor.component.html",
    styleUrls: ["./revisor.component.css"],
    providers: [UserService, FormService]
})

export class RevisorComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;

    public rut_ind;
    public invalidRut: Boolean;
    public revisor: Revisor;
    public rows = [];
    public actualRow;
    public matcher = new FormService();

    public filteredOptions;
    public nombreComuna = new FormControl('', [ Validators.required]);
    options = []
    public selectedRev:number = null;

    

    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService){
        
            this.rut_ind = this.fb.group({
                rut: ['', [Validators.required, this.rutValidator]]
            })

            if (!JSON.parse(localStorage.getItem("revisor"))) {
                localStorage.setItem("revisor", JSON.stringify(this.rows));
            } else {
                this.rows = JSON.parse(localStorage.getItem("revisor"));
            }
            this.invalidRut = true;
       
        this.revisor = {rut: '',nombre:'', apellido_mat:'',apellido_pat:'', direccion: '',direccion_num:'',direccion_complemento:'', direccion_completa:'', comuna:'',fono:'', fax:'',mail:'', patente:'', recordId:''};
    }

    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }

      private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
    
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
      }

    get_revisor(rut){
        this.spinner.show();
        this.cleanData();
        this._userService.getRevisor(rut).subscribe(
            response => {
                if(response.message){
                    this.revisor.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.revisor.rut = response.rut ? response.rut : '';
                    this.revisor.nombre = response.nombre ? response.nombre : '';
                    this.revisor.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.revisor.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.revisor.direccion = response.direccion ? response.direccion : '';
                    this.revisor.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.revisor.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.revisor.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.revisor.comuna = response.comuna ? response.comuna : '';
                    this.revisor.fono = response.fono ? response.fono : '';
                    this.revisor.fax = response.fax ? response.fax : '';
                    this.revisor.mail = response.mail ? response.mail : '';
                    this.revisor.patente = response.patente ? response.patente : '';
                    this.revisor.registro = response.registro ? response.registro : '';
                    this.revisor.categoria = response.categoria ? response.categoria : '';
                    this.revisor.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                    console.log(this.revisor)
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }

    cleanData(){
        this.revisor = {rut: '',nombre:'', apellido_mat:'',apellido_pat:'', direccion: '',direccion_num:'',direccion_complemento:'', direccion_completa:'', comuna:'',fono:'', fax:'',mail:'', patente:'', registro:'', categoria:'', recordId:''};
            this.rut_ind.reset()
    }

    
    update_revisor(rut, id) {
        this.get_revisor(rut);
        this.selectedRev = id;
    }


    saverevisor() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.revisor.rut == this.rows[x].rut) {                
                this.delete_revisor(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedRev != null) {
            this.delete_revisor(this.selectedRev);
            this.selectedRev = null;
        }*/

        this.spinner.show();
        this._userService.saveRevisor(this.revisor).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#ind_modal").modal("hide");
                    this.actualRow = localStorage.getItem("revisor");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.revisor.rut,
                        nombre: this.revisor.nombre,
                        apellido_mat: this.revisor.apellido_mat,
                        apellido_pat: this.revisor.apellido_pat,
                        direccion:this.revisor.direccion, 
                        direccion_num:this.revisor.direccion_num, 
                        direccion_complemento:this.revisor.direccion_complemento, 
                        direccion_completa:this.revisor.direccion_completa, 
                        comuna:this.revisor.comuna, 
                        fono:this.revisor.fono,
                        fax:this.revisor.fax,
                        mail:this.revisor.mail,
                        patente:this.revisor.patente,
                        registro:this.revisor.registro,
                        categoria:this.revisor.categoria
                    })
                    localStorage.setItem("revisor", JSON.stringify(this.rows));
                    this.revisor = {rut: '',nombre:'', apellido_mat:'',apellido_pat:'', direccion: '',direccion_num:'',direccion_complemento:'', direccion_completa:'', comuna:'',fono:'', fax:'',mail:'', patente:'', registro:'', categoria:'',recordId:''};
                    this.rut_ind.reset();
                    this.dialog.closeAll();
                    
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    
    delete_revisor(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("revisor", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('revisor'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}